import { render, staticRenderFns } from "./order_wait_delivery_detail.vue?vue&type=template&id=27740fc9&scoped=true"
import script from "./order_wait_delivery_detail.vue?vue&type=script&lang=js"
export * from "./order_wait_delivery_detail.vue?vue&type=script&lang=js"
import style0 from "./order_wait_delivery_detail.vue?vue&type=style&index=0&id=27740fc9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27740fc9",
  null
  
)

export default component.exports